
export enum TipoProrrateoEnum {
    FECHA_CONTRATACION = 'FECHA_CONTRATACION',
    FECHA_CONTRATACION_Y_FECHA_FIN_CONTRATO = 'FECHA_CONTRATACION_Y_FECHA_FIN_CONTRATO',
    FECHA_CONTRATACION_EN_PERIODOS_DEFINIDOS = 'FECHA_CONTRATACION_EN_PERIODOS_DEFINIDOS',
    FECHA_ANIVERSARIO_CONTRATACION = 'FECHA_ANIVERSARIO_CONTRATACION'
}